import { render, staticRenderFns } from "./MAM_terminalDetail.vue?vue&type=template&id=b067129c&scoped=true&"
import script from "./MAM_terminalDetail.vue?vue&type=script&lang=js&"
export * from "./MAM_terminalDetail.vue?vue&type=script&lang=js&"
import style0 from "./MAM_terminalDetail.vue?vue&type=style&index=0&id=b067129c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b067129c",
  null
  
)

export default component.exports